<template>
    <GmapMap
        :center="mapCenter"
        :zoom="mapZoom"
        :map-type-id="mapType"
        :options="mapOptions"
        class="gmap"
        ref="gmap"
    >
        <GmapMarker
                :key="index"
                v-for="(m, index) in mapMarkers"
                :position="m.position"
                :icon="m.icon"
                :clickable="true"
                :draggable="false"
                :title="m.title"
        >
        </GmapMarker>
    </GmapMap>
</template>

<script>
    import Vue from 'vue';
    import * as VueGoogleMaps from 'vue2-google-maps';

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyBR8aL1BmtxtDwv2HwtWLx8v9iC1F0Rgfo',
            libraries: 'places'
        },
        installComponents: true
    });

    export default {
        data() {
            return {
                mapMarkers: [
                    {
                        'position': { lat: parseFloat(this.location.position.lat), lng: parseFloat(this.location.position.lng) },
                        'title': this.location.title,
                        'address': this.location.address,
                        'url': this.location.url,
                        'icon': this.location.icon || '/assets/img/map-marker.png'
                    }
                ],
                mapCenter: { lat: parseFloat(this.location.position.lat), lng: parseFloat(this.location.position.lng) },
                mapZoom: 16,
                mapType: 'roadmap',
                mapOptions: {
                    backgroundColor: '#f8f8fc',
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    scaleControl: true,
                    zoomControl: true,
                    minZoom: 6,
                    restriction: {
                        latLngBounds: {
                            north: 80,
                            south: -80,
                            west: -179,
                            east: 179
                        },
                        strictBounds: true
                    },
                    styles: [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e9e9e9"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dedede"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        }
                    ]
                },
                clusterStyles: [
                    {
                        textColor: '#ffffff',
                        textSize: 15,
                        url: '/assets/img/map-cluster.png',
                        height: 46,
                        width: 46
                    }
                ],
                infoWindow: '',
                stores: [],
                near: '',
                loading: false
            }
        },
        props: {
            location: {
                type: Object,
                default: () => ({
                    'position': { lat: 50.855024, lng: 4.3402849 },
                    'title': 'Title',
                    'address': `address`,
                    'url': 'url'
                })
            },
        },

    }
</script>